"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("../../../libs/hooks");

function InfoInverseIcon(_ref) {
  var className = _ref.className,
      style = _ref.style;
  var color = (0, _hooks.useTheme)().rainbow.palette.text.header;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    className: className,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: color,
    d: "M10.5.5c5.522 0 10 4.478 10 10s-4.478 10-10 10-10-4.478-10-10c0-5.523 4.477-10 10-10zm0 .952a9.048 9.048 0 100 18.096 9.048 9.048 0 000-18.096zm-.51 7.142c.59 0 1.044.144 1.364.428.319.284.48.654.48 1.11 0 .093-.012.26-.034.497a3.397 3.397 0 01-.122.653l-.61 2.161c-.05.174-.095.372-.135.594-.04.221-.06.39-.06.504 0 .287.064.483.193.587.128.104.351.157.667.157.15 0 .316-.027.505-.079.187-.051.322-.097.408-.137l-.164.667c-.49.194-.88.34-1.173.442a3.083 3.083 0 01-1.017.152c-.594 0-1.056-.145-1.385-.434a1.402 1.402 0 01-.492-1.102c0-.174.012-.351.036-.532a6.72 6.72 0 01.118-.612l.614-2.167c.054-.208.1-.405.138-.59.037-.185.055-.355.055-.51 0-.275-.058-.469-.171-.578-.116-.108-.332-.162-.656-.162-.158 0-.32.024-.487.073a6.26 6.26 0 00-.427.142l.162-.668c.402-.163.786-.304 1.153-.42a3.401 3.401 0 011.04-.176zm1.356-3.955c.4 0 .744.133 1.028.4.285.268.427.59.427.965 0 .376-.142.697-.427.962a1.457 1.457 0 01-1.028.396c-.4 0-.745-.132-1.032-.396a1.269 1.269 0 01-.43-.962c0-.375.146-.697.43-.964a1.46 1.46 0 011.032-.401z"
  }));
}

InfoInverseIcon.propTypes = {
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
InfoInverseIcon.defaultProps = {
  className: undefined,
  style: undefined
};
var _default = InfoInverseIcon;
exports["default"] = _default;